import { redirectorKeys } from './constants'

import { createEventEmitter } from '../event'

export const redirectEventEmitter = createEventEmitter()

export const emitRedirectEvent = data => {
    redirectEventEmitter.emit(redirectorKeys.REDIRECT, data)
}
